import * as OrderTexts from '../../../../../../../intl'
import { form } from '../../../../formState'

import { OrderFormValues } from '../../../../typings'
import { Props } from '../../typings'

import { TimeWindowField } from './components/TimeWindowField'

import validateTimeWindow from './validation/validateTimeWindow'

export function TimeWindows(props: Props) {
  const { orderStepType, workingDayStartSec } = props

  const fieldName = `${orderStepType}.timeWindows` as 'pickup.timeWindows' | 'delivery.timeWindows'

  form.useAddFieldValidation<typeof fieldName>(fieldName, (field, _formApi) => {
    const timeWindows = field.value

    if (timeWindows) {
      const timeWindowsErrors: string[] = timeWindows.map(tw => {
        const isValid = validateTimeWindow(tw, workingDayStartSec)
        return isValid ? '' : OrderTexts.getValidationErrorTimeWindowsValuesText()
      })

      const hasErrors = timeWindowsErrors.some(e => e !== '')
      if (hasErrors) {
        return JSON.stringify(timeWindowsErrors)
      }
    }
  })

  return (
    <TimeWindowField<`${typeof orderStepType}.timeWindows`, OrderFormValues>
      name={`${orderStepType}.timeWindows`}
      timeWindowProps={{
        testId: 'timeWindows',
        label: OrderTexts.getTimeWindowListText(),
      }}
    />
  )
}
